import React from "react";
import { ComponentBootstrap } from "@demant/react-bootstrap";
import flexSpotSchema from "@demant/react-bootstrap/lib/schemas/flex-spot";
var componentSlider = function componentSlider(_ref) {
  var settings = _ref.settings;
  var items = settings.elements[0].items;
  var baseUrl = items.find(function (item) {
    return item.type === "link";
  }).link.href;
  // list of useful query params: http://docs.ipaper.io/flipbook/integration/query-string-parameters
  var url = baseUrl + "?HideStandardUI=true";
  return /*#__PURE__*/React.createElement("div", {
    className: "component flexspot-ipaper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ipaper-container responsive-iframe "
  }, /*#__PURE__*/React.createElement("iframe", {
    className: "ipaper-iframe",
    src: url,
    allow: "autoplay; fullscreen;",
    allowFullScreen: true,
    webkitallowfullscreen: "true",
    mozallowfullscreen: "true"
  })));
};
var myComponent = new ComponentBootstrap(".flex-spot.flexspot-ipaper");
myComponent.schemaData = flexSpotSchema;
myComponent.reactApp = componentSlider;
myComponent.run();